export class NavigationCategory {
  label: string;
  link: string;
  src: string;
  routeParameter: string;
  constructor(label: string, link: string, src: string, routeParameter?: string) {
    this.label = label;
    this.link = link;
    this.src = src;
    this.routeParameter = routeParameter ? routeParameter : null;
  }
}



// WEBPACK FOOTER //
// ./src/components/app/infrastructure/models/navigationCategory.ts